import { useState, useEffect, lazy, Suspense, useContext } from "react"
import { useParams } from 'react-router'
import ThemeContext from '../context/ThemeContext';
import api from '../components/api'
import styles from '../assets/css/module/article.module.css'
const ArticleLists = lazy(() => import ('../components/Food/Expert'))
const ArticleDetail = lazy(() => import ('../components/Food/ExpertDetail'))

export default function Expert(props) {
    const params = useParams();
    const [expert_id, setExpertID] = useState(params.expertId);
    const { language, page, init } = useContext(ThemeContext);

    useEffect(()=>{
        window.addEventListener("scroll", reveal);
        reveal();
        if(params.expertId){
          setExpertID(params.expertId);
        }
    },[]);

    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
    }

    return (
        <div className={styles["article-container"]}>
          {(expert_id)?
            <div className={"content reveal"}>
                <ArticleDetail styles={styles} expert_id={params.expertId} />
            </div>
          :
            <div className={"content reveal"}>
                <ArticleLists styles={styles} />
            </div>
          }
        </div>
    )
}